export enum ReportingFieldType {
    SUMABLE = "sumable",
    AVERAGABLE = "averagable",
    CALCULATED = "calculated"
}